module.exports = {
  ADDRESSCLOUD_ENV: process.env.REACT_APP_ADDRESSCLOUD_ENV,
  AUTH_DOMAIN: process.env.REACT_APP_AUTH_DOMAIN,
  AUTH0_AUDIENCE: process.env.REACT_APP_AUTH0_AUDIENCE,
  AUTH0_CALLBACK_URL: process.env.REACT_APP_AUTH0_CALLBACK_URL,
  AUTH0_CLIENT_ID: process.env.REACT_APP_AUTH0_CLIENT_ID,
  AUTH0_DOMAIN: process.env.REACT_APP_AUTH0_DOMAIN,
  AUTH0_NAMESPACE: process.env.REACT_APP_AUTH0_NAMESPACE,
  BATCH_SIZE: parseInt(process.env.REACT_APP_BATCH_SIZE || 1),
  COUNTRIES: (process.env.REACT_APP_COUNTRIES || 'gb,im,je,gg,ie').split(','),
  DEBUG: process.env.REACT_APP_DEBUG === 'true' || false,
  LOG_EVERY: parseInt(process.env.REACT_APP_LOG_EVERY || 10),
  MAX_ROWS: parseInt(process.env.REACT_APP_MAX_ROWS || 1000),
  MAX_SIZE: parseInt(process.env.REACT_APP_MAX_SIZE || 1000000),
  NATHAN_BATCH_SIZE: parseInt(process.env.REACT_APP_NATHAN_BATCH_SIZE || 100),
  VERSION: process.env.REACT_APP_VERSION,
}
